import * as angular from 'angular';

class NetworkPointDetailsOperatorInfoTermsComponentCtrl
    implements ng.IController
{
    public isCreateMode: boolean;
    public isEditMode: boolean;
    public termsExpanded: boolean = true;
    public networkPoint: NetworkPointDto;

    constructor(private $scope: angular.IScope) {}

    $onInit(): void {
        this.$scope.$watch(
            () => this.networkPoint.ownerTso0,
            (newValue, oldValue) => {
                if (newValue === '') {
                    this.networkPoint.ownerTso0 = null;
                    this.networkPoint.ownerTerms0 = null;
                }
            }
        );
    }
}

angular.module('app').component('pkpNetworkPointDetailsOperatorInfoTerms', {
    controller: NetworkPointDetailsOperatorInfoTermsComponentCtrl,
    template:
        require('app/network-point/network-point-details-operator-info-terms.component.html'),
    bindings: {
        form: '=',
        networkPoint: '=',
        isEditMode: '<',
        isCreateMode: '<'
    }
});
